import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { fromGlobalId } from 'graphql-relay';
import Segment from '../../components/Segment';
import Item from '../../components/Item';
import Icon from '../../components/Icon';
import messages from './messages';

import './styles.css';

const UpcomingFair = ({ collegeFair, highSchoolID }) => (
  <Segment styleName="upcoming-fair-container">
    <Item.Group>
      <Item>
        <Icon name="info circle" size="big" />
        <Item.Content>
          <Item.Header styleName="upcoming-fair-header">
            <FormattedMessage {...messages.upcomingFair} />
          </Item.Header>
          <Item.Meta>
            <FormattedMessage {...messages.upcomingFairDetails} />
            <FormattedDate value={`${collegeFair.date}T12:00:00`} year="numeric" month="long" day="numeric" />
            <Link to={`/rep-visits/search/${fromGlobalId(highSchoolID).id}/fairs`} styleName="asLinkBtn upcoming-fair-details-btn">
              <FormattedMessage {...messages.seeDetails} />
            </Link>
          </Item.Meta>
        </Item.Content>
      </Item>
    </Item.Group>
  </Segment>
);

UpcomingFair.propTypes = {
  collegeFair: PropTypes.object.isRequired,
  highSchoolID: PropTypes.string.isRequired,
};

export default UpcomingFair;
